<template>
	<div class="flex-fill w-100 card" v-if="words.length > 0">
  	  	<div class="card-header">
  	    	<h5 class="mb-0 card-title">Tags les plus utilisés</h5>
		</div>
		<div class="p-3 card-body">
	    	<vue-word-cloud style="height: 300px;"
				:words="words"
				font-family="Roboto"
				:spacing="1"/>
        </div>
	</div>
</template>

<script>
import VueWordCloud from 'vuewordcloud';

export default {
	components: {
	    [VueWordCloud.name]: VueWordCloud,
	},
	data() {
		return {
			words: []
		}
	},
	created() {
   		axios.get('/wikidataTagCloud').then(response => {
        	this.words = response.data;
        }).catch(err => {
            console.log(err)
        });
	}
}
</script>